"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.models = exports.createNetworkAudit = exports.createLocationAudit = exports.getActions = void 0;
const axios_1 = require("axios");
const moment = require("moment");
const models = require("../models/audits");
exports.models = models;
const shared_1 = require("./shared");
async function getActions(accessToken, correlationId, resourceType, resourceId, createdBefore = moment().toISOString()) {
    const getAll = async (paginationUrl) => {
        const url = paginationUrl || `${shared_1.getBaseUrl()}/v0/audits/${resourceType}/${resourceId}`;
        const request = {
            headers: shared_1.getHeaders(accessToken, correlationId),
        };
        if (!paginationUrl) {
            request.params = { createdBefore };
        }
        try {
            const response = (await axios_1.default.get(url, request)).data;
            const actions = response.items;
            if (response._links.next) {
                actions.push(...(await getAll(response._links.next.href)));
            }
            return actions;
        }
        catch (error) {
            if (error.response && error.response.status === 404) {
                return undefined;
            }
            throw error;
        }
    };
    return getAll();
}
exports.getActions = getActions;
async function createLocationAudit(accessToken, correlationId, locationId, audit) {
    await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/audits`, audit, {
        headers: shared_1.getHeaders(accessToken, correlationId),
    });
}
exports.createLocationAudit = createLocationAudit;
async function createNetworkAudit(accessToken, correlationId, networkId, audit) {
    await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/networks/${networkId}/audits`, audit, {
        headers: shared_1.getHeaders(accessToken, correlationId),
    });
}
exports.createNetworkAudit = createNetworkAudit;
//# sourceMappingURL=audits.v0.js.map